import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { getLink } from '../services/link-service';
import Global from '../store/global-selectors';
import { LocaleContext } from '../intl/locale-context-provider';

export const useGetLink = (linkId) => {
  const homeCountry = useSelector(Global.selectSellerHomeCountry);
  const { locale } = useContext(LocaleContext);

  return getLink(linkId, homeCountry, locale);
};
